import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { businessBenefits } from './cardReader.config';
import {
  ActionContainer,
  BusinessBenefit,
  BusinessBenefitsContainer,
  BusinessBenefitsContent,
  UnlimitedContainer,
  UnlimitedLabel,
} from './cardReader.styled';

const { VITE_PARTNERS_BASE_URL, VITE_CDN_BASE_URL } = getEnv();

export const CardReader = () => {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };

  return (
    <BusinessBenefitsContainer>
      <WidthContainer noBackground>
        <Image
          src={`${VITE_CDN_BASE_URL}/images/image-terminal-with-pata.webp`}
          alt="Card payment using a card terminal"
          height={1500}
          width={2500}
        />
        <BusinessBenefitsContent>
          <h2>
            <span>PataPay </span> card reader
            <br />
            Swipe. Tap. Done!
          </h2>

          <p>
            Accept in-person payments with the <strong> PataPay Card Reader</strong> – a sleek and easy-to-use terminal
            designed for pet care businesses.
          </p>
          <p>
            At just £79 per card reader, you can ensure a seamless experience for your clients while providing secure
            transactions and low processing fees for your business.
          </p>
          <p>
            The PataPay Card Reader is also integrated with our pet care software, allowing you to track all payments
            and bookings in one place.
          </p>

          <ActionContainer>
            <Button onClick={handleSignUpClick}>Sign up and order the card reader</Button>
          </ActionContainer>
        </BusinessBenefitsContent>
      </WidthContainer>
    </BusinessBenefitsContainer>
  );
};
